'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = SequenceColumn;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fixedDataTable = require('fixed-data-table-2');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SequenceColumn(props) {
	var enableLink = props.enableLink,
	    startSequence = props.startSequence,
	    enableAddDelrow = props.enableAddDelrow,
	    footer = props.footer,
	    onAddrow = props.onAddrow,
	    onDelrow = props.onDelrow,
	    onClick = props.onClick;


	var getContent = function getContent(ps) {

		//序号列显示内容，如果有开始序号那么加上
		var text = startSequence ? startSequence + ps.rowIndex + '' : ps.rowIndex + 1 + '';

		//启用链接，会响应click事件
		if (enableLink) {
			return _react2.default.createElement(
				'div',
				{ className: 'mk-datagrid-sequence-cell', onClick: onClick ? function () {
						return onClick(ps);
					} : undefined },
				enableAddDelrow ? _react2.default.createElement(_icon2.default, { type: 'plus', className: 'mk-datagrid-editable-add-row', onClick: function onClick() {
						return onAddrow ? onAddrow(ps) : undefined;
					} }) : null,
				_react2.default.createElement(
					'a',
					null,
					text
				),
				enableAddDelrow ? _react2.default.createElement(_icon2.default, { type: 'close', className: 'mk-datagrid-editable-remove-row', onClick: function onClick() {
						return onDelrow ? onDelrow(ps) : undefined;
					} }) : null
			);
		}

		return _react2.default.createElement(
			'div',
			{ className: 'mk-datagrid-sequence-cell' },
			enableAddDelrow ? _react2.default.createElement(_icon2.default, { type: 'plus', className: 'mk-datagrid-editable-add-row', onClick: function onClick() {
					return onAddrow ? onAddrow(ps) : undefined;
				} }) : null,
			_react2.default.createElement(
				'a',
				{ style: { color: "#444444", cursor: "default" } },
				text
			),
			enableAddDelrow ? _react2.default.createElement(_icon2.default, { type: 'close', className: 'mk-datagrid-editable-remove-row', onClick: function onClick() {
					return onDelrow ? onDelrow(ps) : undefined;
				} }) : null
		);
	};

	return _react2.default.createElement(_fixedDataTable.Column, {
		key: '_sequence',
		width: 42,
		fixed: true,
		cell: function cell(ps) {
			return getContent(ps);
		},
		header: _react2.default.createElement(
			_fixedDataTable.Cell,
			null,
			'\u5E8F\u53F7'
		),
		footer: footer
	});
}
module.exports = exports['default'];